import React from 'react'
import CustomDropdown from '../../../../../../components/dropdown/CustomDropdown'
import toast from 'react-hot-toast'
import { useMutation, useQuery } from 'react-query'
import { errorResponse } from '../../../../../../components/utils/errorResponse'
import { api as learningPath } from '../../../../../../api/learningPath'
import addGroupImage from '../../../../../../assets/Add Group.png'

const AddLearningPath = ({ 
  setCurrentStep, selectedJourney, setSelectedJourney, cohort
}: any) => {

  const orgId = JSON.parse(sessionStorage.getItem('user')!)?.org?.id

  const { data, isLoading } = useQuery(
    ["view journeys"],
    () => learningPath.getLearningPath({ perPage: 10000, currentPage: 1, org_id: orgId, search: '' }),
    {
      cacheTime: 100,
      staleTime: 100,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      enabled: !!orgId,
      select: (response) => response?.data,
    }
  )

    const addCohortMutation: any = useMutation(learningPath.assignCohorts, {
      onSuccess: () => {
        toast.remove()
        toast.success('Learning Path Added Successfully!')
        refetchAssignedLearningPaths()
        setSelectedJourney(null)
      },
      onError: (error) => errorResponse(error),
      onMutate: () => {
        toast.loading('Loading...')
      }
    })

 const addLearningPath = () => {
    if (selectedJourney === null) {
      toast.error('Error! Select Learning Path To Proceed.')
      return
    }

    const payload = {
      org_id: orgId,
      journey_id: selectedJourney?.value,
      payload: {
        allCohorts: false,
        newCohortIds: [cohort?.id],
      },
    }

    addCohortMutation.mutate(payload)
  }

  const removeLearningPath = (item: any) => {
    removeLearningPathMutation.mutate({
      org_id: orgId,
      journey_id: item?.journey?.id,
      journeyCohortId: item?.id,
    })
  }

 const {
  data: assignedLearningPaths,
  isLoading: assignedLoading,
  refetch: refetchAssignedLearningPaths,
} = useQuery(
  ["journey-cohorts", orgId, cohort?.id],
  () =>
    learningPath.getJourneyCohorts({
      org_id: orgId,
      cohort_id: cohort?.id,
    }),
  {
    enabled: !!cohort?.id,
    select: (data) => data?.data,
  }
);

const removeLearningPathMutation: any = useMutation(
  learningPath.removeJourneyCohort,
  {
    onMutate: () => {
      toast.loading('Removing...')
    },
    onSuccess: () => {
      toast.remove()
      toast.success('Learning Path Removed Successfully!')
      refetchAssignedLearningPaths()
    },
    onError: (error) => errorResponse(error),
  }
)

  const journeyOptions = (data || [])
    .filter((journey: any) => !assignedLearningPaths?.some((item: any) => item?.journey?.id === journey?.id))
    .map((journey: any) => ({ label: journey?.name, value: journey?.id }))

  return (
    <>   
           <section className='border flex justify-between pr-0 px-7 border-slate-400 rounded-lg mx-3 mt-8'>
             <div className='w-[40%] py-7 flex items-center justify-center'>
                 <img src={addGroupImage} className='w-[260px] h-[260px]' alt="add group" />
             </div>
               <section className='w-[52%]'>
               <div className='rounded-e-lg bg-white h-full p-5 px-8'>
                  <h5 className='text-xl font-semibold'>
                    Add Learning Path
                  </h5>
                  <p className='text-xs font-semibold border-b border-gray-300 pb-2 mt-1 mb-3'>
                      Select learning path for your cohort
                  </p>
                  <label className='text-xs pb-2'> Select Learning Path </label>
                 <CustomDropdown
                    value={selectedJourney}
                    options={isLoading ? [] : journeyOptions}
                    onChange={(value: any) => setSelectedJourney(value)}
                    placeholder={'Select Learning Path'}
                    onBlur={null}
                    className={'bg-primaryGray select-custom'}
                    name={'path'}
                    width={'w-full mt-2'}
                 />
                  <div className='flex mt-8'>
                    <button
                      type='button'
                      className='w-full text-center btn bg-primary-blue'
                      onClick={addLearningPath}
                    >
                      Add Learning Path
                    </button>
                  </div>

                  <div className='mt-8'>
                    <h5 className='text-lg font-semibold mb-3'>Assigned Learning Paths</h5>

                    {assignedLoading ? (
                      <p className='text-sm text-slate-500'>Loading assigned learning paths...</p>
                    ) : assignedLearningPaths?.length ? (
                  <div className="mt-3 flex flex-wrap gap-2">
  {assignedLearningPaths.map((item: any) => (
    <div
      key={item.id}
      className="flex items-center gap-2 rounded-full bg-blue-50 border border-blue-200 px-3 py-2"
    >
      <span className="text-sm font-medium ">
        {item?.journey?.name}
      </span>

      <button
        type="button"
        onClick={() => removeLearningPath(item)}
        className="flex items-center justify-center text-red-500 hover:text-red-700"
      >
        <i className="bi bi-x-circle-fill"></i>
      </button>
    </div>
  ))}
</div>
                    ) : (
                      <p className='text-sm text-slate-500'>No Learning Path assigned.</p>
                    )}
                  </div>
             </div>
            </section> 
      </section>
    </>
  )
}

export default AddLearningPath